enum TypePeriode {
	DEMANDE = 0,
	PROPOSE = 1,
	VOTE = 2,
	CA_CFU = 3,
}

// Libelle de la periode dans les messages ("... en periode Vote")
export const LIBELLES_PERIODE: Record<TypePeriode, string> = {
	[TypePeriode.DEMANDE]: 'Demande',
	[TypePeriode.PROPOSE]: 'Proposition',
	[TypePeriode.VOTE]: 'Vote',
	[TypePeriode.CA_CFU]: "Fin d'année",
};

// Periodes ou le calcul des lignes budgetaires est disponible
export const PERIODES_CALCUL = [TypePeriode.DEMANDE, TypePeriode.PROPOSE];

export default TypePeriode;
